export default __webpack_public_path__ + "static/media/background_global.03f16be5.jpg";